import React, { FC, ReactNode, useState } from 'react';
import classNames from 'classnames';
import { Asset, ChevronIcon } from '@clearcover/atlas';
import styles from './styles.module.css';

export const Accordion: FC<{
  className?: string;
}> = ({ className, children }) => {
  return (
    <ul className={classNames(styles.recordList, className)}>{children}</ul>
  );
};

type AccordionItemPropsType = {
  actions?: (setIsOpen: (isOpen: boolean) => void) => ReactNode;
  editable?: boolean;
  header: ReactNode;
  footer?: ReactNode | null;
  identifier: string;
  startOpen?: boolean;
  autoOpenNewEntries?: boolean;
  className?: string;
  cssOverrides?: {
    headerContainer?: string;
    collapsibleContent?: string;
    listItem?: string;
  };
  onToggleClick?: () => void;
};

export const AccordionItem: FC<AccordionItemPropsType> = ({
  actions,
  editable,
  header,
  identifier,
  footer,
  children,
  className,
  onToggleClick,
  startOpen = false,
  cssOverrides = {},
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(startOpen);

  const handleToggle = () => {
    onToggleClick?.();
    setIsOpen(prevIsOpen => !prevIsOpen);
  };

  return (
    <div className={classNames(styles.recordContainer, className)}>
      <li
        className={classNames(styles.record, cssOverrides.listItem)}
        data-testid={identifier}
      >
        <div
          className={classNames(
            styles.headerContainer,
            cssOverrides.headerContainer
          )}
          data-testid={`toggle-accordion-id-${identifier}`}
          data-open-state={isOpen ? 'open' : 'closed'}
        >
          <div
            data-testid={`toggle-accordion-click-${identifier}`}
            onClick={handleToggle}
            className={classNames('fs-mask', styles.recordHeader)}
          >
            {header}
          </div>
          {editable && actions && (
            <div className={styles.actions}>{actions(setIsOpen)}</div>
          )}
          <div
            onClick={handleToggle}
            className={classNames(styles.chevron, {
              [styles.openChevron]: isOpen,
            })}
          >
            <Asset
              className={styles.icon}
              icon={ChevronIcon}
              description="toggle-icon"
              height={12}
              width={12}
            />
          </div>
        </div>
        {isOpen && (
          <div
            className={classNames(
              styles.collapsibleContent,
              cssOverrides.collapsibleContent
            )}
          >
            {children}
          </div>
        )}
      </li>

      {isOpen && footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
};
